export const enum FreeSpinsInfoEvent {
  FreeFreeSpinsGroupName = 'free',
  PurchasedFreeSpinsGroupName = 'purchased',
  FreeSpinsStarted = 'started',
  FreeSpinsFinished = 'finished',
  FreeSpinsGroupSwitched = 'groupSwitched',
  FreeSpinsAdded = 'added',
}

export const enum FreeSpinsInfoName {
  Free = 'free',
  FreeFrozen = 'freeFrozen',
  /**
   * @deprecated use ReSpin instead */
  FreeRespin = 'freeRespin',
  ReSpin = 'reSpin',
}

export class FreeSpinsGroup {
  count: number | null;
  usedCount = 0;
  lines: number;
  name: string | null;
  bet: number;
  marker: string | null;
  win: number;
  betCalculation: string;
  multiplier: number;
}

export class FreeSpinsInfo {
  count: number;
  name: FreeSpinsInfoName;
  freeSpinGroups: FreeSpinsGroup[] | null;
  totalWin: number;
  baseGameWin: number;
  freeSpinsAdded: number | null;
  currentFreeSpinsGroup: FreeSpinsGroup | null;
  totalFreeSpins: number;
  event: FreeSpinsInfoEvent | null;
  parameter: number | null;

  public getFullWin(): number {
    return this.totalWin + this.baseGameWin;
  }
}
